import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useSession } from "@/services/auth0/session";

interface QueueTokenResponse {
  token: string;
  expiresIn: number;
}

export function useGetQueueToken() {
  const { token } = useSession();

  return useMutation<QueueTokenResponse, Error>({
    mutationFn: async () => {
      const { data } = await axios.post<QueueTokenResponse>(
        `${import.meta.env.VITE_API_URL}/api/v2/admin/queues/token`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return data;
    },
  });
}

export function useBullBoardRedirect() {
  const mutation = useGetQueueToken();

  const openBullBoard = async () => {
    const result = await mutation.mutateAsync();
    const url = `${import.meta.env.VITE_API_URL}/admin/queues?token=${result.token}`;
    window.open(url, "_blank");
  };

  return {
    openBullBoard,
    isLoading: mutation.isPending,
    error: mutation.error,
  };
}
